import api from "../../../services/api";

const APIS = {
  REQUESTED_LIST_DATA: "/RequestList/RequestedSamplesList",
  STATUS_DATA: "/RequestList/status/customer",
  STATES_DATA: "/Location/states",
  SPECIES_DATA: "/Species",
  PRODUCT_TYPE_DATA: "/ProductTypes",
  EXPORT_REPORT: "/Reports/export",
  LAB_ANALYSIS_REPORT: "/Sample/lab-analysis-report-pdf",
};

export const getRequestedListData = async (payload = {}) => {
  try {
    const response = await api.post(APIS.REQUESTED_LIST_DATA, payload);
    return response.data;
  } catch (error) {
    console.error("Error fetching Tasks all data:", error);
    throw error;
  }
};

export const getStatusData = async () => {
  try {
    const response = await api.get(APIS.STATUS_DATA);
    return response.data;
  } catch (error) {
    console.error("Error fetching Status data:", error);
    throw error;
  }
};

export const getStatesData = async () => {
  try {
    const response = await api.get(APIS.STATES_DATA);
    return response.data;
  } catch (error) {
    console.error("Error fetching States data:", error);
    throw error;
  }
};

export const getSpeciesData = async () => {
  try {
    const response = await api.get(APIS.SPECIES_DATA);
    return response.data;
  } catch (error) {
    console.error("Error fetching Species data:", error);
    throw error;
  }
};

export const getProductTypeData = async () => {
  try {
    const response = await api.get(APIS.PRODUCT_TYPE_DATA);
    return response.data;
  } catch (error) {
    console.error("Error fetching Product Type data:", error);
    throw error;
  }
};

export const exportReport = async (groupIds = [], sampleIds = []) => {
  try {
    let url = APIS.EXPORT_REPORT;
    const params = new URLSearchParams();

    if (groupIds.length > 0) {
      groupIds.forEach(id => {
        if (id !== null && id !== undefined && id !== '') {
          params.append('GroupIds', id);
        }
      });
    } else if (sampleIds.length > 0) {
      sampleIds.forEach(id => {
        if (id !== null && id !== undefined && id !== '') {
          params.append('SampleIds', id);
        }
      });
    }

    if (!params.toString()) {
      throw new Error('No valid GroupIds or SampleIds provided');
    }

    const response = await api.get(`${url}?${params.toString()}`, {
      responseType: 'blob'
    });

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', 'report.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);

    return { success: true };
  } catch (error) {
    console.error("Error exporting report:", error);
    throw error;
  }
};

export const downloadLabAnalysisReport = async (sampleIds = []) => {
  try {
    let url = APIS.LAB_ANALYSIS_REPORT;
    const params = new URLSearchParams();

    sampleIds.forEach(id => params.append('sampleIds', id));

    const response = await api.get(`${url}?${params.toString()}`, {
      responseType: 'blob'
    });

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', 'lab-analysis-report.pdf');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);

    return { success: true };
  } catch (error) {
    console.error("Error downloading lab analysis report:", error);
    throw error;
  }
};
